import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
export let browserRefresh = false;

import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyService } from 'src/app/services/currency.service';
import { UiTranslationService } from 'src/app/services/ui-translation.service';

@Component({
  selector: 'app-dish',
  templateUrl: './dish.component.html',
  styleUrls: ['./dish.component.css']
})
export class DishComponent implements OnInit {

  @Input() dishes: any[] = [];
  @Input() selectedIndex: number = 0;

  @ViewChild('slickModal') slickModal!: SlickCarouselComponent;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    swipe: true,
    lazyLoad: 'ondemand',
    speed: 300,

    vertical: true,
    verticalSwiping: true,
  };

  constructor(public activeModal: NgbActiveModal, public currencyService: CurrencyService,
    public i18n: UiTranslationService) { }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.slickModal?.slickGoTo(this.selectedIndex);
    }, 0);
  }

  close() {
    this.activeModal.close();
  }

  getBackgroundStyle(imageUrl: string | undefined) {
    imageUrl = imageUrl?.replace('https://bravum.cl/Images', 'assets/Images');
    const backgroundImage = imageUrl ? `url(${this.getUrlImage(imageUrl)})` : 'url(https://placehold.it/70x70)';

    return {
      'background': backgroundImage,
      'background-repeat': 'no-repeat',
      'background-size': '140px',
      'background-position': 'left center',
      'width': '140px',
      'height': '140px',
      'margin': 'auto',
      'border-radius': '15px',
      'position': 'relative'
    };
  }

  getUrlImage(url: string) {
    const imagen = url.replace('https://bravum.cl/assets/Images/', './assets/Images/');

    return imagen;
  }


}
